module.exports = __webpack_public_path__ + "static/media/cow.0e00cb24.jpg";